import firebase from 'firebase';
import _ from 'lodash';

import View from '../../../_components/view/view.js';
import playerTpl from './player.tpl.html';
import './player.styles.less';

import ConfirmModal from '../../../_modals/confirm-modal/confirm-modal.view.js';
import LinkPlayerModal from '../_modals/link-player-modal/link-player-modal.view.js';

class PlayerView extends View {

	constructor (data, options) {
		super(playerTpl, data, _.extend(options, {
				viewClass: 'player'
			})
		);
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			playerImage: '.player-image',
			btnEdit: '.btn-edit',
			btnDelete: '.btn-delete',
			btnLinkPlayer: '.btn-link-player',
			btnUnlinkPlayer: '.btn-unlink-player'
		});
	}

	render(data) {
		super.render(data);

		if (this.data.userId) {
			this.ui.playerImage.removeClass('hidden');
		}
	}

	initializeEvents() {
		this.ui.btnEdit.click(() => this.trigger('edit:player', this.options.__player));
		this.ui.btnDelete.click(() => this.deletePlayer());
		this.ui.btnLinkPlayer.click(() => this.linkPlayer());
		this.ui.btnUnlinkPlayer.click(() => this.unlinkPlayer());
	}

	deletePlayer() {
		new ConfirmModal(
			`Are you sure you want to delete the user?<br>
				This action <b>CANNOT</b> be undone
			`,
			'Confirm user deletion'
		).open().then( confirm => {
			if (confirm) {
				this.options.__player.ref.remove();
			}
		});
	}

	linkPlayer() {
		firebase.database().ref('users/').once('value')
		.then( __users => {
			new LinkPlayerModal(
				this.options.__player,
				__users
			).open().then( () => {
				
			});
		});
	}

	unlinkPlayer() {
		this.options.__player.ref.update({
			userId: null,
			photoURL: null
		});
	}

	/*onShow() {

	}*/


	remove() {
		super.remove();
		this.ui.btnDelete.off();
	}

}

export default PlayerView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/players/player/player.view.js